module.exports = __webpack_public_path__ + "img/primevue-logo.2954558d.png";